<template>
  <div>
    <b-row>
      <b-col xxs="12">
        <h3>{{ $t("Şifre Değiştir") }}</h3>
        <div class="mb-4"></div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form-group :label="$t('Eski Şifre')">
          <b-form-input v-model="form.password_old"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('Yeni Şifre')">
          <b-form-input v-model="form.password"></b-form-input>
        </b-form-group>
        <b-form-group :label="$t('Yeni Şifre Tekrar')">
          <b-form-input v-model="form.password_confirmation"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col sm="12" class="text-right">
        <b-button @click.prevent="changePasswordAction" variant="primary">{{ $t("Şifreyi Güncelle") }}</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    name: 'ChangePassword',
    data(){
      return {
        form: {
          password_old: '',
          password: '',
          password_confirmation: '',
        },
      }
    },
    methods: {
      ...mapActions(['changePassword']),
      changePasswordAction(){
        this.changePassword(this.form).then(response => {
          this.success(response.data);
        }).catch(error => {
          this.error(error.response.data);
        });
      }
    },
  }
</script>
